import { useEffect } from "react";
import { SITE_URL } from "../seo/routes";

export const Seo = ({ title, description, path, lang, alternates, noindex }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      const m = document.querySelector('meta[name="description"]');
      if (m) m.setAttribute("content", description);
    }
    if (path != null) {
      const c = document.querySelector('link[rel="canonical"]');
      if (c) c.setAttribute("href", `${SITE_URL}${path === "/" ? "/" : path}`);
    }
    if (noindex) {
      const r = document.querySelector('meta[name="robots"]');
      if (r) r.setAttribute("content", "noindex, nofollow");
    }
    document.documentElement.lang = lang || "en-CA";
    document.querySelectorAll('link[rel="alternate"][data-maze]').forEach((n) => n.remove());
    (alternates || []).forEach((a) => {
      const l = document.createElement("link");
      l.rel = "alternate";
      l.hreflang = a.lang;
      l.href = a.href;
      l.setAttribute("data-maze", "1");
      document.head.appendChild(l);
    });
  }, [title, description, path, lang, noindex, JSON.stringify(alternates)]);
  return null;
};
